import request from '@/utils/request'

// 买家列表
export const buyer_list=(data)=>{
  return request({
    url: '/erp-pos/base-buyer/index',
    method: 'get',
    data
  })
}

// 买家新增 
export const buyer_create=(data)=>{
  return request({
    url: '/erp/base-buyer/edit__role',
    method: 'post',
    data
  })
}

// 买家新增 || 编辑
export const buyer_update=(data)=>{
  return request({
    url: '/erp/base-buyer/edit',
    method: 'post',
    data
  })
}

// 买家详情--业务信息
export const buyer_detail_base=(data)=>{
  return request({
    url: '/erp/base-buyer/info',
    method: 'get',
    data
  })
}

// 买家详情--采购详情
export const buyer_detail_order=(data)=>{
  return request({
    url: '/erp-pos/base-buyer/order',
    method: 'get',
    data
  })
}

// 买家详情--还款详情
export const buyer_detail_repayment=(data)=>{
  return request({
    url: '/erp-pos/base-buyer/repayment-list',
    method: 'get',
    data
  })
}

// 买家详情--历史订单
export const buyer_history_repayment=(data)=>{
  return request({
    url: '/erp/base-buyer/history-debt',
    method: 'get',
    data
  })
}
// 还款记录--上放总览统计
export const buyer_history_total=(data)=>{
  return request({
    url: '/erp-pos/base-buyer/repayment-statistics',
    method: 'get',
    data
  })
}
// 买家管理列表--点名首字母列表
export const buyer_firstNameList=(data)=>{
  return request({
    url: '/erp-pos/base-buyer/first-name-list',
    method: 'get',
    data
  })
}
